import React, { useState } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import FilterTab from "../../../../../ReusableComponents/FilterDropDown/FilterTab";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UpdateInsDetailsPopup from "./UpdatePopUp";
import UploadFilePopUp_New from "../../../../../ReusableComponents/UploadFile/UploadFileNew";

export default function ListNewInsurance({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  const [Popup, setPopUp] = useState(false);
  const [popOpenDoc, setPopUpDoc] = useState(false);
  const [listData, setListData] = useState();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadLoadingTem, setDownloadLoadingTem] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [filter, setFiltered] = React.useState(list?.data);

  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(filter || []);

  const getData = async (keyword) => {
    console.log(keyword.length);
    try {
      if (keyword.length >= 3) {
        const response = await nodeinstance.get(
          `employee-insurance/insuranceSearch?keyword=${keyword}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setFiltered(response.data.data);
      } else {
        if (keyword.length == 0) {
          updateData();
        }
      }
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };
  const apiCall = () => {
    updateData();
    // navigate(`/dashboard/fin-insurance/`);
  };

  function filterStatus(item) {
    if (item === "All") {
      setFiltered(list?.data);
      return;
    }
    setFiltered(list?.data.filter((emp) => emp.insurance_status === item));
  }

  useEffect(() => {
    setFiltered(list?.data);
  }, [list]);

  //edit text Field
  const downloadFile = async (url, fileName) => {
    try {
      const response = await nodeinstance.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoadingTem(false);
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  console.log("Insurance list to be seen here in console", currentList);
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => setPopUp(true)}
          >
            <p>update insurance data</p>
            {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
          </button>

          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => {
              downloadFile(
                "/employee-insurance/downloadInsuranceTemplate",
                "Employee_Insurance_Template"
              ),
                setDownloadLoadingTem(true);
            }}
            disabled={downloadLoadingTem || list?.isLoading}
          >
            <p>Download Insurance Data Template</p>
            {downloadLoadingTem && <CgSpinner className="animate-spin" />}
          </button>
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => {
              downloadFile(
                `/employee-insurance/downloadInsuranceExcel`,
                "INSURANCE_APPLICATION_DOWNLOAD"
              );
              setDownloadLoading(true);
            }}
            disabled={downloadLoading || list?.isLoading}
          >
            <p>download Application</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>
          <input
            type="search"
            className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
            placeholder={"enter search emp id"}
            onChange={(e) => {
              var dataValue = e.target.value;
              getData(dataValue);
            }}
          />

          <FilterTab
            changeHandeler={filterStatus}
            status={[
              "All",
              "Application Pending",
              "Payment Pending",
              "Insurance Done",
            ]}
          />
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[4530px]">
              <div className="grid grid-cols-table-insurance gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-insurance gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {!list?.isLoading && <NoDataFound />}
              {!list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.point_of_hire || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.arrival_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.nationality || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.emp_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.Client_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.border_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.dob || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.relation || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.gender || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.marital_status || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.class || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.mobile_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={"" || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.sponsor_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.arrival_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.health_conditions || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.issue_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.membership_no || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.status || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.policy_no || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.insurance_co || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.remarks || "-"}
                      />
                    </p>
                    {list.point_of_hire === "LOCAL" ? (
                      <button
                        className={
                          "px-2 rounded-md  bg-red text-white text-xs mr-5 h-8"
                        }
                        onClick={() => {
                          setListData(list);
                          setPopUpDoc(true);
                        }}
                      >
                        Update Insurance
                      </button>
                    ) : (
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.insurance_status || "-"}
                        />
                      </p>
                    )}

                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <UploadFilePopUp_New
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Insurance"}
          url={"employee-insurance/updateInsuranceFromExcel"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
      {popOpenDoc ? (
        <UpdateInsDetailsPopup
          token={token}
          listData={listData}
          PopUp={popOpenDoc}
          setPopUp={setPopUpDoc}
          title={"Bulk UPLOAD Documents"}
          url={`/drivingLicense/bulkuploadLicenseDoc/`}
          callBack={updateData}
          fileFormat={"> Driving-License-Iqama Number"}
        />
      ) : (
        ""
      )}
    </>
  );
}
